var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63741 1.64712C5.20191 1.64712 4.84682 2.00113 4.84682 2.44241C4.84682 2.83226 4.53079 3.14829 4.14094 3.14829C3.75109 3.14829 3.43506 2.83226 3.43506 2.44241C3.43506 1.22722 4.41644 0.235352 5.63741 0.235352H9.89153C11.1096 0.235352 12.0986 1.22433 12.0986 2.44241C12.0986 2.83226 11.7826 3.14829 11.3927 3.14829C11.0029 3.14829 10.6868 2.83226 10.6868 2.44241C10.6868 2.00402 10.3299 1.64712 9.89153 1.64712H5.63741Z",
    fill: "#FF6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05405 4.47349C2.44232 4.43842 2.7855 4.72474 2.82057 5.11301L3.61129 13.8674C3.63556 14.1425 3.86636 14.353 4.14108 14.353H11.3881C11.6629 14.353 11.8937 14.1425 11.9179 13.8674L11.9181 13.866L12.7086 5.11301C12.7437 4.72474 13.0869 4.43842 13.4752 4.47349C13.8634 4.50856 14.1498 4.85174 14.1147 5.24001L13.3242 13.9915C13.3242 13.9919 13.3242 13.9923 13.3241 13.9928C13.2348 14.9971 12.393 15.7647 11.3881 15.7647H4.14108C3.13607 15.7647 2.2941 14.9968 2.20506 13.9923C2.20503 13.992 2.20501 13.9918 2.20499 13.9915L1.41453 5.24001C1.37946 4.85174 1.66578 4.50856 2.05405 4.47349Z",
    fill: "#FF6161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1175 4.94116C6.50735 4.94116 6.82339 5.2572 6.82339 5.64704V12.2353C6.82339 12.6251 6.50735 12.9412 6.1175 12.9412C5.72766 12.9412 5.41162 12.6251 5.41162 12.2353V5.64704C5.41162 5.2572 5.72766 4.94116 6.1175 4.94116Z",
    fill: "#FF6161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41194 4.94116C9.80179 4.94116 10.1178 5.2572 10.1178 5.64704V12.2353C10.1178 12.6251 9.80179 12.9412 9.41194 12.9412C9.02209 12.9412 8.70605 12.6251 8.70605 12.2353V5.64704C8.70605 5.2572 9.02209 4.94116 9.41194 4.94116Z",
    fill: "#FF6161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.941406 2.91291C0.941406 2.52307 1.25744 2.20703 1.64729 2.20703H13.8826C14.2724 2.20703 14.5885 2.52307 14.5885 2.91291C14.5885 3.30276 14.2724 3.6188 13.8826 3.6188H1.64729C1.25744 3.6188 0.941406 3.30276 0.941406 2.91291Z",
    fill: "#FF6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutlined);
export default __webpack_public_path__ + "static/media/trash-outlined.f0870c65cc522d90a1e1b6b897cb1eb6.svg";
export { ForwardRef as ReactComponent };